import styled from 'styled-components';

export const StyledSwitchContainer = styled.span<{
  size: 'small' | 'normal';
  edge: 'end' | 'start' | false;
}>`
  width: 58px;
  height: 38px;
  display: inline-flex;
  padding: 12px;
  z-index: 0;
  overflow: hidden;
  position: relative;
  box-sizing: border-box;
  flex-shrink: 0;
  vertical-align: middle;
  color: #668afe;
  ${({ edge }) => edge === 'start' && 'margin-left: -9px;'}
  ${({ edge }) => edge === 'end' && 'margin-right: -9px;'}

  ${({ size, edge }) =>
    size === 'small' &&
    `
      width: 40px;
      height: 24px;
      padding: 7px;

      ${edge === 'start' ? 'margin-left: -4px;' : ''}
      ${edge === 'end' ? 'margin-right: -4px;' : ''}

      & ${StyledThumb} {
        margin: 4px;
        width: 16px;
        height: 16px;
      }

      ${StyledInputSwitch}:checked ~ ${StyledThumb} {
        transform: translateX(16px);
      }
  `}
`;

export const StyledInputSwitch = styled.input`
  left: -100%;
  width: 300%;
  top: 0;
  cursor: pointer;
  height: 100%;
  margin: 0;
  opacity: 0;
  padding: 0;
  z-index: 1;
  position: absolute;
`;

export const StyledThumb = styled.span`
  width: 20px;
  height: 20px;
  box-shadow: 0 0 1px 0 rgb(0 0 0 / 12%), 0 1px 1px 0 rgb(0 0 0 / 24%),
    inset 0 0 0 0.5px rgb(0 0 0 / 4%), inset 0 0 0 0.5px rgb(255 255 255 / 12%);
  border-radius: 50%;
  position: absolute;
  z-index: 0;
  top: 0;
  left: 0;
  transition: left 150ms cubic-bezier(0.4, 0, 0.2, 1) 0ms,
    transform 150ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;
  margin: 9px;
  background-color: #fafafa;

  ${StyledInputSwitch}:checked ~ & {
    background-color: currentColor;
    transform: translateX(20px);
  }

  ${StyledInputSwitch}:disabled ~ & {
    background-color: #bdbdbd;
  }
`;

export const StyledTrack = styled.span`
  width: 100%;
  height: 100%;
  z-index: -1;
  transition: opacity 150ms cubic-bezier(0.4, 0, 0.2, 1) 0ms,
    background-color 150ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;
  border-radius: 7px;
  background-color: #ededed;

  ${StyledInputSwitch}:checked ~ & {
    opacity: 0.5;
    background-color: #c6d3ff;
  }

  ${StyledInputSwitch}:disabled ~ & {
    opacity: 0.12;
    background-color: #000;
  }
`;
